import React from 'react';
import { StyledButton } from '../../styles/utils';
import { useEnhancedNavigation } from '../../hooks';
import { px2vw } from '../../utils';
import { ReferrerInvalidTip } from '../../recommend';
import { SuccessWrapper } from './styles';

type Props = {
  isMobile?: boolean;
  showReferrerInvalidTip?: boolean; // 线索推荐重复提交的提示
  type?: 'reserve' | 'primary';
};

const successText = {
  primary: {
    title: '提交成功',
    desc: (
      <p className="desc">
        我们将在<strong>1-3</strong>个工作日联系您，与你具体沟通合作事宜
      </p>
    ),
  },
  reserve: {
    title: '您的预约已提交',
    desc: (
      <p className="desc">
        我们的专属顾问会在1个工作日内与您联系
        <br />
        紧急问题请拨打 <strong>(0571)89852163</strong> 转 <strong>21951</strong> 进行快速解答{' '}
      </p>
    ),
  },
};

export const SubmitSuccess = ({ type = 'primary', isMobile = false, showReferrerInvalidTip = false }: Props) => {
  const enhancedNavigate = useEnhancedNavigation();
  const useHigherMarginTop = type === 'primary' && !showReferrerInvalidTip;

  return (
    <SuccessWrapper isMobile={isMobile}>
      <img src="https://static.fuxi.netease.com/yaotai/portal/20220609/l46xvb7q_形状@2x.png" alt="" />
      <p className="title">{successText[type].title}</p>
      {showReferrerInvalidTip ? <ReferrerInvalidTip /> : successText[type].desc}
      <StyledButton
        styleType={isMobile ? 'primary' : 'default'}
        className="success-btn"
        onClick={() => enhancedNavigate('/')}
        style={{
          marginTop: `${
            isMobile ? (useHigherMarginTop ? px2vw(110) : px2vw(74)) : useHigherMarginTop ? '72px' : '48px'
          }`,
        }}>
        回到首页
      </StyledButton>
    </SuccessWrapper>
  );
};

export default SubmitSuccess;
